import React from "react";

import { MxDashboard } from "./MxDashboard";
import Dashboard from "./validationDashboard/Dashboard";
import { Tabs } from "@shared/ui/tabs";


const UnifiedDashboard: React.FC = () => {
  const tabComponents = {
    "meter-summary": {
      label: "Resource Summary",
      component: <MxDashboard />,
       className: "whitespace-nowrap overflow-visible"
    },
    "meter-read-validation": {
      label: "Resource Read Validation",
      component: <Dashboard />,
       className: "whitespace-nowrap overflow-visible"
    }
  };

  const urlMapping = {
    "meter-summary": "summary",
    "meter-read-validation": "validation"
  };

  return (
    <div>
      <span>
        <p className="page-title">Resource Dashboard</p>
        <p className="page-subtitle">A unified view to monitor resource status, consumption, and performance insights.</p>
      </span>
      <Tabs
      defaultValue="meter-summary"
      tabComponents={tabComponents}
      urlMapping={urlMapping}
      tabsListClassName="mt-4 [&>*]:flex-1 [&>*]:min-w-0" 
      tabsListFullWidth={true}  
      className="w-full"
    />
    </div>
  );
};

export default UnifiedDashboard;

